// The org's department list, from the master-data 'departments' dataset.
// Departments are not a table of their own — see docs/specs/workflows-listing-split-view.md §6.

import { useMemo } from 'react';
import { useMasterDataList } from '@/lib/sdk/master-data/queries';

export const DEPARTMENTS_DATASET = 'departments';

export interface DepartmentOption {
  key: string;
  label: string;
}

export function useDepartments(orgId: string) {
  const { data, isLoading } = useMasterDataList(orgId, {
    dataset: DEPARTMENTS_DATASET,
    // A filter dropdown, not a browsable table — one page covers it.
    page_size: 200,
  });

  const departments = useMemo<DepartmentOption[]>(
    () =>
      (data?.items ?? [])
        .map((row) => ({ key: row.key, label: row.label }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [data]
  );

  return { departments, isLoading };
}
